<template>
    <HeaderList></HeaderList>
    <div class="category relative pt-12 h-max bg-theme-gray flex">
        <CategoryView></CategoryView> 
        
    </div>
</template>

<script>
import HeaderList from '@/components/HeaderList.vue';
import CategoryView from '@/components/CategoryView.vue';



export default {
    name: 'category',
    components: {
        HeaderList,
        CategoryView,

    }
};
</script>